import request from "@/util/http";
import qs from "qs"; // 获取树形结构的节点

export function getPageDeskVo(params) {
  return request({
    url: "/admin/homeTemplate/getPageDeskVo",
    method: "get",
    params: params
  });
}
export function stuAndteachStastic(data) {
  return request({
    // url: `/admin/bpmn/stastics/stuAndteachStastic`,
    url: "/admin/homeServe/hostServe",
    // method: "post",
    method: "get",
    headers: {
      token: window.sessionStorage.bpmnSid
    },
    data: data
  });
}